import React, { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE } from '../utils/motion';
type RevealProps = {
  children: ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={reduce ? false : {
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.28,
    delay,
    ease: EASE
  }} data-id="element-67" data-mp="3gfe53fuemy67">
      {children}
    </motion.div>;
}